import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "early-access-cta__text" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "early-access-cta__title" }, " Congratulations - you have early access to our new Podcast guides! ", -1)
const _hoisted_3 = { class: "early-access-cta__subtitle" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:help@shortform.com" }, "help@shortform.com", -1)

import EarlyAccessBanner from '@/app/components/doc/EarlyAccessBanner.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'EarlyAccessBannerPodcast',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(EarlyAccessBanner, null, {
    text: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(" We have big plans, so please suggest podcasts and "),
          _createVNode(_component_router_link, { to: { name: 'help' } }, {
            default: _withCtx(() => [
              _createTextVNode("report problems here")
            ]),
            _: 1
          }),
          _createTextVNode(" or email "),
          _hoisted_4
        ])
      ])
    ]),
    _: 1
  }))
}
}

})